// ======================================================================
// File Name       : enterpriseNotification
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../constants/actionTypes/enterpriseNotification';
import { RETURN_MAX_NUM } from '../constants/index';

const initialState = {
  filterData: {
    noticeForEnterpriseSecernId: '',
    noticeList: [],
    noticeTitle: '',
    releaseTargetForEnterprise: null,
    publicStatus: null,
    publicDateFrom: null,
    publicDateTo: null,
    noticeSortType: null,
    ascendingDescendingSort: null,
    startPosition: 0,
  },
  noticeForEnterpriseList: {
    allSecernIds: [],
    bySecernId: {},
    recordNum: 0,
    csvFileLink: '',
  },
  registerSuccess: false,
  editSuccess: false,
};

export default function enterpriseNotification(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.ENTERPRISE_NOTIFICATION_LIST: {
      const { resultEnterpriseNotificationList } = action;
      const recordNum = resultEnterpriseNotificationList.recordNum;
      const csvFileLink = resultEnterpriseNotificationList.csvfileUrl;
      let noticeForEnterpriseList = {};
      if (resultEnterpriseNotificationList && resultEnterpriseNotificationList.noticeList) {
        noticeForEnterpriseList = resultEnterpriseNotificationList.noticeList.reduce(
          (acc, cur) => {
            const { noticeForEnterpriseSecernId } = cur;
            acc.bySecernId[noticeForEnterpriseSecernId] = cur;
            acc.allSecernIds.push(noticeForEnterpriseSecernId);
            return acc;
          },
          {
            bySecernId: {},
            allSecernIds: [],
            recordNum,
            csvFileLink,
          },
        );
      }
      return { ...state, ...{ noticeForEnterpriseList } };
    }
    default: {
      return {
        ...state,
      };
    }
  }
}
